import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import SportsSoccerRoundedIcon from "@mui/icons-material/SportsSoccerRounded";
import AppLayout from "../../components/ui/AppLayout";
import PageHeader from "../../components/ui/PageHeader";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import GameCard from "./GameCard";
import api from "../../api";

const CACHE_EXPIRATION = 1 * 24 * 60 * 60 * 1000; // 1 dia em milissegundos

// Lista pública (admin = false): o mesmo torneio da página inicial, o mais recente com jogos.
// Admin: torneio salvo em cache; senão o torneio ativo.
async function getTorneio(admin) {
  if (!admin) return (await api.get("/getTorneioComJogos")).data;
  const cachedData = localStorage.getItem('TORNEIO_ID');
  const cachedTimestamp = localStorage.getItem('TORNEIO_ID_timestamp');
  if (cachedData && cachedTimestamp && new Date().getTime() - parseInt(cachedTimestamp, 10) <= CACHE_EXPIRATION) {
    return JSON.parse(cachedData);
  }
  const response = await api.get("/getTorneioActive");
  return response.data;
}

// Lista de jogos do torneio. `admin` habilita edição e lançamento de gols/cartões.
const ListarJogosPage = ({ admin = true }) => {
  const navigate = useNavigate();
  const [jogos, setJogos] = useState([]);
  const [torneio, setTorneio] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJogos = async () => {
      try {
        const torneioAtual = await getTorneio(admin);
        setTorneio(torneioAtual);
        const response = await api.get(`/jogosTorneio/${torneioAtual._id}`);
        setJogos(response.data.jogos.sort((a, b) => new Date(a.dataJogo) - new Date(b.dataJogo)));
      } catch (error) {
        console.error("Erro ao buscar jogos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchJogos();
  }, []);

  return (
    <AppLayout>
      <PageHeader
        backTo={admin ? "/torneio" : "/squad"}
        eyebrow={torneio?.nome || "Torneio"}
        title="Jogos"
        subtitle={admin ? "Clique em um jogo para lançar gols, assistências e cartões." : "Resultados e destaques de cada partida."}
        actions={admin && <Button variant="contained" startIcon={<AddRoundedIcon />} onClick={() => navigate("/cadastrar-jogo")}>Novo jogo</Button>}
      />
      {loading ? (
        <LoadingState label="Carregando jogos..." />
      ) : jogos.length === 0 ? (
        <Card><EmptyState icon={<SportsSoccerRoundedIcon />} title="Nenhum jogo cadastrado" /></Card>
      ) : (
        <Grid container spacing={2}>
          {jogos.map((jogo) => (
            <Grid item xs={12} md={6} key={jogo._id}>
              <GameCard
                jogo={jogo}
                onClick={admin ? () => navigate(`/jogos/${jogo._id}/detalhes`) : undefined}
                actions={admin && (
                  <Button size="small" startIcon={<EditRoundedIcon />} onClick={() => navigate(`/editar-jogo/${jogo._id}`)}>
                    Editar jogo
                  </Button>
                )}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </AppLayout>
  );
};

export default ListarJogosPage;
